import { defineMessages } from 'react-intl';

export const scope = 'axionoee.features.components.machinesections';

export default defineMessages({
    editMachineSectionsButtonLabel: {
        id: `${scope}.editMachineSectionsButtonLabel`,
        defaultMessage: 'Machine sections',
    },
    nameColumn: {
        id: `${scope}.grid.column.name`,
        defaultMessage: 'Name',
    },
    codeColumn: {
        id: `${scope}.grid.column.code`,
        defaultMessage: 'Code',
    },
    sortOrderColumn: {
        id: `${scope}.grid.column.sortOrder`,
        defaultMessage: 'Sort order',
    },
    stopReasonCodesColumn: {
        id: `${scope}.grid.column.stopReasonCodes`,
        defaultMessage: 'Stop codes',
    },
    addMachineSectionTitle: {
        id: `${scope}.grid.addMachineSectionTitle`,
        defaultMessage: 'Add machine section',
    },
    editMachineSectionTitle: {
        id: `${scope}.grid.editMachineSectionTitle`,
        defaultMessage: 'Edit machine section',
    },
    editStopReasonCodesTitle: {
        id: `${scope}.grid.editStopReasonCodesTitle`,
        defaultMessage: 'Stop codes for section',
    },
    deleteMachineSectionTitle: {
        id: `${scope}.grid.deleteMachineSectionTitle`,
        defaultMessage: 'Delete machine section',
    },
    editStopReasonCodesButtonLabel: {
        id: `${scope}.grid.editStopReasonCodesButtonLabel`,
        defaultMessage: 'Stop codes',
    },
    saveButton: {
        id: `${scope}.saveButton`,
        defaultMessage: 'Save',
    },
    nameIsMandatory: {
        id: `${scope}.nameIsMandatory`,
        defaultMessage: 'The section needs to have a name',
    },
    stopReasonCodesHelpText: {
        id: `${scope}.stopReasonCodesHelpText`,
        defaultMessage: 'Only stop codes already available for this machine can be selected.',
    },
});
